import * as Yup from 'yup'

const customerRefundCustomerBankFormSchema = Yup.object().shape(
  {
    name        : Yup.string().required('bank name required'),
    name_others : Yup.string()
      .when('name', {
        is   : (value) => value === 'others',
        then : Yup.string().required(
          'bank name required'
        ),
        otherwise: Yup.string()
      }),
    holder_name    : Yup.string().required('bank holder name required'),
    account_number : Yup.string()
      .matches(/^[-+]?[0-9]+$/, 'Only number allowed')
      .required('bank account no. required')
  }
)

export default customerRefundCustomerBankFormSchema
